var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgencies(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.8 9.35H.85a.85.85 0 00-.85.85v5.95a.85.85 0 00.85.85H6.8a.85.85 0 00.85-.85V10.2a.85.85 0 00-.85-.85zm-.85 5.95H1.7v-4.25h4.25v4.25zM16.15 0H10.2a.85.85 0 00-.85.85V6.8a.85.85 0 00.85.85h5.95A.85.85 0 0017 6.8V.85a.85.85 0 00-.85-.85zm-.85 5.95h-4.25V1.7h4.25v4.25zm.85 3.4H10.2a.85.85 0 00-.85.85v5.95a.85.85 0 00.85.85h5.95a.85.85 0 00.85-.85V10.2a.85.85 0 00-.85-.85zm-.85 5.95h-4.25v-4.25h4.25v4.25zM6.8 0H.85A.85.85 0 000 .85V6.8a.85.85 0 00.85.85H6.8a.85.85 0 00.85-.85V.85A.85.85 0 006.8 0zm-.85 5.95H1.7V1.7h4.25v4.25z",
    fill: "#8A9AA7"
  })));
}
export default SvgAgencies;